import {Injectable} from "@angular/core";
import {Dialog, DialogRef} from '@angular/cdk/dialog';
import {LoadingPopupComponent} from "@app/presentation/services/loading/loading-popup.component";

@Injectable()
export class LoadingPopupService {

    dialogRef: DialogRef<unknown, LoadingPopupComponent> | null = null;

    constructor(
        private dialog: Dialog,
    ) {
    }

    show() {
        //If the dialog is already open, do nothing
        if (this.dialogRef) {
            return;
        }
        this.dialogRef = this.dialog.open(LoadingPopupComponent, {
            disableClose: true,
        })
    }

    hide() {
        this.dialogRef?.close();
        this.dialogRef = null;
    }
}
